module.exports = __webpack_public_path__ + "static/img/wl1750.eaaf6f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/wl1750.jpg
// module id = IDnR
// module chunks = 0